import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Cached reseller dropdown options.
 * Selection lives in the URL (?reseller_id=) — see shared/scope/listScope.ts.
 */
export const useResellerContextStore = defineStore('resellerContext', () => {
  const resellerOptions = ref<{ label: string; value: string | number }[]>([])
  const isLoadingResellers = ref(false)
  const optionsLoaded = ref(false)

  function setResellerOptions(options: { label: string; value: string | number }[]) {
    resellerOptions.value = options
    optionsLoaded.value = true
  }

  function clear() {
    resellerOptions.value = []
    optionsLoaded.value = false
    isLoadingResellers.value = false
  }

  return {
    resellerOptions,
    isLoadingResellers,
    optionsLoaded,
    setResellerOptions,
    clear
  }
})
